// extracted by mini-css-extract-plugin
export default {"button":"focus-button_button__BFS4U","focused":"focus-button_focused__mcpVq","img":"focus-button_img__y2vR6"};